const pm = {
  // ==================== PLANT MAINTENANCE (Platzhalter / Modul-Kachel) ====================
  'pm.title': 'Plant Maintenance',
  'pm.subtitle': 'Instandhaltungsaufträge, Wartungspläne und technische Objekte verwalten',

  // ==================== PLANT-MAINTENANCE-MODUL (portiert aus i18n/*.json, Praefix pm.) ====================
  'pm.common.loading': 'Lädt…',
  'pm.common.back': 'Zurück',
  'pm.common.next': 'Weiter',
  'pm.common.done': 'Fertig',
  'pm.common.clear': 'Leeren',
  'pm.common.loadError': 'Daten konnten nicht geladen werden.',
  'pm.common.retry': 'Erneut versuchen',
  'pm.header.reset': 'Daten zurücksetzen',
  'pm.header.resetConfirm': 'Alle im Test angelegten Daten löschen und auf den Ausgangsstand zurücksetzen?',
  'pm.role.mechanic': 'Mechaniker',
  'pm.role.supervisor': 'Meister',
  'pm.search.placeholder': 'z. B. Pumpe, 10004711…',
  'pm.home.title': 'Was suchen Sie?',
  'pm.home.subtitle': 'Gerät, Auftrag oder Material — einfach tippen.',
  'pm.home.actions': 'Aktionen',
  'pm.recent.title': 'Zuletzt verwendet',
  'pm.home.soon': 'bald',
  'pm.home.notActive': '„{label}“ ist in diesem Prototyp noch nicht aktiv.',
  'pm.home.resetDone': 'Demo-Daten zurückgesetzt.',
  'pm.action.create-order.label': 'Auftrag anlegen',
  'pm.action.create-order.sub': 'In 3 Schritten',
  'pm.action.create-notification.label': 'Meldung erfassen',
  'pm.action.create-notification.sub': 'Problem + Foto',
  'pm.action.my-orders.label': 'Meine Aufträge',
  'pm.action.my-orders.sub': 'Liste & Rückmeldung',
  'pm.action.material-search.label': 'Material finden',
  'pm.action.material-search.sub': 'Visuelle Suche',
  'pm.action.backlog.label': 'Auftragsbestand',
  'pm.action.backlog.sub': 'Offene Aufträge',
  'pm.action.approvals.label': 'Freigaben',
  'pm.action.approvals.sub': 'Prüfen & freigeben',
  'pm.order.steps.device': 'Gerät',
  'pm.order.steps.problem': 'Problem',
  'pm.order.steps.confirm': 'Bestätigen',
  'pm.order.whichDevice': 'Welches Gerät?',
  'pm.order.problemLabel': 'Was ist das Problem?',
  'pm.order.problemPlaceholder': 'Kurz beschreiben…',
  'pm.order.pastNotifications': 'Frühere Meldungen an diesem Gerät:',
  'pm.order.priority': 'Priorität',
  'pm.order.confirmTitle': 'Auftrag bestätigen',
  'pm.order.fieldDevice': 'Gerät',
  'pm.order.fieldProblem': 'Problem',
  'pm.order.fieldPriority': 'Priorität',
  'pm.order.fieldOrderType': 'Auftragsart',
  'pm.order.fieldPlant': 'Werk',
  'pm.order.fieldWorkCenter': 'Arbeitsplatz',
  'pm.order.longTextLabel': 'Details (optional)',
  'pm.order.longTextPlaceholder': 'Ausführliche Beschreibung — Diktat landet hier, ohne Zeichenbegrenzung.',
  'pm.order.fieldLongText': 'Details',
  'pm.order.detailsShow': 'Details ändern',
  'pm.order.detailsHide': 'Details ausblenden',
  'pm.order.defaultsNote': 'Vorbelegt aus Ihrem Profil. (Bearbeitung im Prototyp eingeschränkt.)',
  'pm.order.createBtn': 'Auftrag anlegen',
  'pm.order.creating': 'Wird angelegt…',
  'pm.order.createHint': 'Wird in SAP angelegt (über den Mock-Adapter)',
  'pm.order.successTitle': 'Auftrag angelegt',
  'pm.order.orderNumber': 'Auftragsnummer',
  'pm.order.duplicateNote': '(bereits vorhanden — kein Duplikat erstellt)',
  'pm.order.addPartsNow': 'Auftrag öffnen & Teile hinzufügen',
  'pm.order.openCreated': 'Auftrag öffnen',
  'pm.order.errorPrefix': 'Fehler',
  'pm.priority.low': 'Niedrig',
  'pm.priority.mid': 'Mittel',
  'pm.priority.high': 'Hoch',
  // Auftragsart-Codes -> Absicht (Demo-Customizing; je Kunde aus sap-contract-requirements.md §6a).
  'pm.orderType.W001': 'Wartung',
  'pm.orderType.W002': 'Reparatur',
  // SAP-Transparenz-Panel (SapPayloadPanel): Felder, die an SAP gehen bzw. aus SAP kamen.
  'pm.sap.show': 'SAP-Felder anzeigen',
  'pm.sap.hide': 'SAP-Felder ausblenden',
  'pm.sap.toSapNote': 'Diese Felder werden an SAP übertragen.',
  'pm.sap.fromSapNote': 'Diese Felder kamen so aus SAP (Mock).',
  'pm.sap.plannedStart': 'Geplanter Start',
  'pm.sap.plannedEnd': 'Geplantes Ende',
  'pm.status.CRTD': 'Angelegt',
  'pm.status.REL': 'Freigegeben',
  'pm.status.CNF': 'Rückgemeldet',
  'pm.status.TECO': 'Abgeschlossen',
  'pm.dash.show': 'Dashboard einblenden',
  'pm.dash.hide': 'Dashboard ausblenden',
  'pm.dash.pendingApprovals': 'Wartende Freigaben',
  'pm.dash.openOrders': 'Offene Aufträge',
  'pm.dash.overdue': 'Überfällig',
  'pm.dash.openNotifications': 'Offene Meldungen',
  'pm.dash.byStatus': 'Nach Status',
  'pm.dash.byType': 'Nach Auftragsart',
  'pm.dash.recentNotifications': 'Neueste Meldungen',
  'pm.dash.empty': 'Keine Daten.',
  'pm.dash.mockBadge': 'Mock-Daten',
  'pm.dash.clickHint': 'Klicken für Liste',
  'pm.week.next7': 'Nächste 7 Tage',
  'pm.week.my': 'Meine Woche',
  'pm.week.overdue': 'Überfällig',
  'pm.week.today': 'Heute',
  'pm.week.unscheduled': 'ohne Termin',
  'pm.orders.myTitle': 'Meine Aufträge',
  'pm.orders.backlogTitle': 'Auftragsbestand',
  'pm.orders.approvalsTitle': 'Freigaben',
  'pm.orders.approvalsHint': 'Aufträge im Status „Angelegt“ — prüfen und freigeben.',
  'pm.orders.empty': 'Keine Aufträge gefunden.',
  'pm.orders.countSuffix': 'Aufträge',
  'pm.orders.countOne': 'Auftrag',
  'pm.detail.title': 'Auftrag',
  'pm.detail.operations': 'Arbeitsgänge',
  'pm.detail.components': 'Komponenten',
  'pm.detail.confirmedShort': 'rückgemeldet',
  'pm.detail.hours': 'Stunden',
  'pm.detail.finalConfirmation': 'Endrückmeldung (Arbeitsgang abschließen)',
  'pm.detail.confirmSubmit': 'Zeit rückmelden',
  'pm.detail.confirming': 'Wird gebucht…',
  'pm.detail.confirmPosted': 'Rückmeldung gebucht',
  'pm.detail.confirmReplayed': 'bereits gebucht — kein Duplikat',
  'pm.detail.release': 'Auftrag freigeben',
  'pm.detail.releasing': 'Wird freigegeben…',
  'pm.detail.releasedNote': 'Auftrag freigegeben — Arbeit kann beginnen.',
  'pm.detail.qty': 'Menge',
  'pm.detail.notFound': 'Auftrag nicht gefunden.',
  // Komponenten uebergeben (SAP erzeugt Reservierung/BANF selbst)
  'pm.comp.add': 'Komponente hinzufügen',
  'pm.comp.addBtn': 'An SAP übergeben',
  'pm.comp.adding': 'Wird übergeben…',
  'pm.comp.stockAtPlant': 'Verfügbar im Werk',
  'pm.comp.shortfallHint': 'Bei Unterdeckung erzeugt SAP automatisch eine Bestellanforderung (BANF).',
  'pm.comp.resShort': 'Res.',
  'pm.comp.prShort': 'BANF',
  'pm.materials.title': 'Material finden',
  'pm.materials.subtitle': 'Beschreibung, Nummer oder Merkmal — z. B. „Lager“ oder „45 mm“.',
  'pm.materials.placeholder': 'z. B. Lager, Dichtung, 9000012352…',
  'pm.materials.available': 'verfügbar',
  'pm.materials.bin': 'Lagerplatz',
  'pm.materials.outOfStock': 'Nicht auf Lager',
  'pm.materials.noResults': 'Keine Treffer.',
  'pm.materials.loadingStock': 'Bestand wird geladen…',
  // Spracheingabe (Tier 1, hinter unternehmensweitem Flag pm_features.voice)
  'pm.voice.disabledMsg': 'Spracheingabe ist unternehmensweit deaktiviert. Das Browser-Diktat sendet Audio an den Browser-Hersteller (Google/Microsoft/Apple) — die Freigabe muss unternehmensweit bestätigt werden, oder es wird ein lokales Sprachmodell auf eigenen Servern eingerichtet.',
  'pm.voice.unsupported': 'Dieser Browser unterstützt keine Spracherkennung (z. B. Firefox). Bitte Chrome, Edge oder Safari verwenden.',
  'pm.voice.start': 'Diktat starten (Push-to-talk)',
  'pm.voice.stop': 'Diktat stoppen',
  'pm.voice.listening': 'Höre zu',
  'pm.voice.transcribing': 'Wird transkribiert…',
  'pm.voice.serverError': 'Lokales Sprachmodell nicht erreichbar. Bitte Administrator informieren (Server prüfen / Verbindungstest erneut ausführen).',
  'pm.voice.micDenied': 'Mikrofonzugriff wurde verweigert — bitte in den Browser-Einstellungen (bzw. Unternehmens-Policy) erlauben.',
  'pm.voice.noMic': 'Kein Mikrofon gefunden. Bitte Mikrofon anschließen und prüfen, ob Windows den Mikrofonzugriff für Apps erlaubt (Einstellungen → Datenschutz → Mikrofon).',
  'pm.voice.insecure': 'Mikrofonzugriff ist nur über localhost oder HTTPS möglich — bitte die Anwendung über eine sichere Adresse öffnen.',
  'pm.voice.micError': 'Mikrofon konnte nicht gestartet werden.',
  'pm.notif.confirmTitle': 'Meldung bestätigen',
  'pm.notif.fieldType': 'Meldungsart',
  'pm.notif.photoHint': 'Foto hinzufügen — im Prototyp noch nicht aktiv',
  'pm.notif.createBtn': 'Meldung anlegen',
  'pm.notif.creating': 'Wird angelegt…',
  'pm.notif.successTitle': 'Meldung angelegt',
  'pm.notif.notifNumber': 'Meldungsnummer',
  'pm.notif.createHint': 'Wird in SAP angelegt (über den Mock-Adapter)',
};

export default pm;
